export const SORT_DESTINATION = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type SortDestination = (typeof SORT_DESTINATION)[keyof typeof SORT_DESTINATION];

export const SPACE_GROUP_ORDER_COLUMN_MAPPING = {
  MONTHLY_RENT_ASC: "monthlyRentValue",
  MONTHLY_RENT_DESC: "monthlyRentValue",
  AVAILABILITY_ASC: "spaceGroupLessorFullNumber",
  AVAILABILITY_DESC: "spaceGroupLessorFullNumber",
  FREE_ASC: "spaceGroupLessorEmptyNumber",
  FREE_DESC: "spaceGroupLessorEmptyNumber",
  FREE_SCHEDULE_ASC: "spaceGroupLessorScheduleNumber",
  FREE_SCHEDULE_DESC: "spaceGroupLessorScheduleNumber",
  MAX_CAPACITY_ASC: "spaceGroupLessorTotalNumber",
  MAX_CAPACITY_DESC: "spaceGroupLessorTotalNumber",
  IS_PUBLIC_ASC: "isSpacePublic",
  IS_PUBLIC_DESC: "isSpacePublic",
  IS_AVAILABILITY_PUBLIC_ASC: "isAvailabilityPublic",
  IS_AVAILABILITY_PUBLIC_DESC: "isAvailabilityPublic",
} as const;

export type SpaceGroupOrder = keyof typeof SPACE_GROUP_ORDER_COLUMN_MAPPING;

export const SPACE_GROUP_ORDER_FIELDS = {
  monthlyRent: "MONTHLY_RENT",
  availability: "AVAILABILITY",
  free: "FREE",
  FREE_DESC: "spaceGroupLessorEmptyNumber",
  FREE_SCHEDULE_ASC: "spaceGroupLessorScheduleNumber",
  FREE_SCHEDULE_DESC: "spaceGroupLessorScheduleNumber",
  MAX_CAPACITY_ASC: "spaceGroupLessorTotalNumber",
  MAX_CAPACITY_DESC: "spaceGroupLessorTotalNumber",
  IS_PUBLIC_ASC: "isSpacePublic",
  IS_PUBLIC_DESC: "isSpacePublic",
  IS_AVAILABILITY_PUBLIC_ASC: "isAvailabilityPublic",
  IS_AVAILABILITY_PUBLIC_DESC: "isAvailabilityPublic",
} as const;

export type SpaceGroupOrderFields =
  | "MONTHLY_RENT"
  | "AVAILABILITY"
  | "FREE"
  | "FREE_SCHEDULE"
  | "MAX_CAPACITY"
  | "IS_AVAILABILITY_PUBLIC"
  | "IS_PUBLIC"
  | "FULL_FULL"
  | "FULL_TEMP"
  | "FULL_EX_SCHEDULE"
  | "EMPTY_NUMBER"
  | "FULL_TEMPORARY_NUMBER"
  | "BOOKED_SPACE_NUMBER"
  | "TOTAL_NUMBER";
